import { Tab, Tooltip, initTE } from "tw-elements";
import $ from "jquery";
import 'jquery.nicescroll';
import 'readmore-js';
import select2 from 'select2';
window.$ = window.jQuery = $;
select2();
(function ($) {
  "use strict";
  window.HAMTA = window.HAMTA || {};

  /*====== Preloader ======*/
  window.agent = $("body").data("agent");
  const isMobile = checkMobile();

  window.onresize = function () {
    if (isMobile != checkMobile()) location.reload();
  };
  document.addEventListener("livewire:navigating", () => {
    window.dispatchEvent(new CustomEvent("unlock-scroll"));
  });
  document.addEventListener("livewire:navigated", () => {
    $(".tooltip-inner").parent().remove();
    $(".back-to-top").fadeOut();
    $(".preloader").fadeOut(function () {
      $(this).remove();
    });
    $("footer").css("padding-bottom", $(".box-price-info").outerHeight());
    HAMTA.StickySidebar();
    HAMTA.NavigateLink();
    HAMTA.Popup();
    HAMTA.Countdown();
    HAMTA.Select2();
    HAMTA.Tooltip();
    HAMTA.Tab();
  });

  function checkMobile() {
    return (
      "serviceWorker" in navigator &&
      /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    );
  }
  /*====== end Preloader ======*/

  HAMTA.EasyNumberSeparator = function () {
    if ($("input.currency").length) easyNumberSeparator();
  };

  HAMTA.Tooltip = function () {
    document
      .querySelectorAll("[data-te-toggle=tooltip]")
      .forEach((elm) => Tooltip.getOrCreateInstance(elm));
  };

  HAMTA.Tab = function () {
    document.querySelectorAll("[data-te-toggle=pill]").forEach((elm) => {
      const tab = new Tab(elm);
      elm.addEventListener("click", (e) => {
        e.preventDefault();
        tab.show();
      });
    });
  };

  HAMTA.Popup = function () {
    const popup = $("#popupModal");
    if (popup.length) {
      setTimeout(() => popup.modal("show"), popup.data("delay"));
      popup.find(".romeo-embed-inner").click(function () {
        $(this).remove();
        document.querySelector("#popupModal video").play();
      });

      popup.on("modal-hide", function () {
        document.cookie =
          "popup_" + popup.data("page") + "_" + popup.data("id") + "=1";
        $(this).remove();
      });
    }
  };

  HAMTA.NavigateLink = function () {
    document.querySelectorAll(".swiper-wrapper a[x-navigate]").forEach((tag) =>
      tag.addEventListener("click", (e) => {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent("hide-search"));
        Livewire.navigate(tag.href);
      })
    );
  };

  /*====== StickyHeader ======*/
 HAMTA.StickyHeader = function () {

    if (window.__stickyHeaderBound) return;
    window.__stickyHeaderBound = true;

    let t = $(".back-to-top");

    function recalc() {
        if ($(".box-price-info").length) {
            t.css("bottom", $(".box-price-info").height() + 16);
        }
    }

    recalc();

    let lastScrollTop = 0;
    const agent = $("body").data("agent");

    window.addEventListener("scroll", () => {

        const header = $(".page-header");
        if (!header.length) return;

        const scrollTop = $(window).scrollTop();

        scrollTop > 1000 ? t.fadeIn(500) : t.fadeOut(500);

        if (agent === "desktop") {
            if (scrollTop > header.height() && scrollTop > lastScrollTop) {
                header.find(".nav-content").addClass("hidden--nav-wrapper");
                header.css("height",  header.find('.banner').height() + header.find(".header-content").height());
            } else {
                header.find(".nav-content").removeClass("hidden--nav-wrapper");
                header.css(
                    "height",
                    header.find('.banner').height() + header.find(".header-content").height() +
                    header.find(".nav-content").height()
                );
            }

            $(".styles_Tabs__XG9uc").css(
                "top",
                $(".header-content").outerHeight() +
                (header.find(".nav-content:not(.hidden--nav-wrapper)").height() || 0) - 1
            );
        }

        lastScrollTop = scrollTop;

        if (header.css("display") === "block") {
            $(".bottom-page-header .has-children.active").css(
                "top",
                header.outerHeight()
            );
        }
    });

    window.addEventListener('resize', recalc);
};
  /*====== end StickyHeader ======*/

  /*====== CategoryList ======*/
  (HAMTA.CategoryList = function () {
    var t;
    $(document).on(
      {
        mouseenter: function () {
          window.dispatchEvent(new CustomEvent("lock-scroll"));
        },
        mouseleave: function () {
          window.dispatchEvent(new CustomEvent("unlock-scroll"));
        },
      },
      ".nav-wrapper > ul > .category-list"
    );
    function setSize(selector) {
      const t = $(".bottom-page-header");
      const i = $(window).width() - (t.offset().left + t.outerWidth());
      const s = selector.parents(".offset-bar");
      const a = s.offset().left;
      selector.find(".wrapper").css({
        width: a - i,
        minHeight: s.height(),
        right: $(window).width() - a - 1,
        top: $(".offset-bar").offset().top,
      });
    }
    // setSize($(".category-list ul:eq(1)>li:eq(0)"));
    // $(".category-list ul:eq(1)>li:eq(0)").addClass("active");
    $(document).on(
      "mouseenter",
      ".page-header ul > .category-list .has-children",
      function () {
        setSize($(this));
      }
    );
    $(document).on(
      {
        mouseenter: function () {
          $(this).hasClass("menu-item-has-mega-menu") ||
            (t && clearTimeout(t),
            $(this).addClass("active").siblings().removeClass("active"));
        },
        mouseleave: function () {
          if (!$(this).hasClass("menu-item-has-mega-menu")) {
            var i = $(this);
            t = setTimeout(function () {
              return i.removeClass("active");
            }, 500);
          }
        },
      },
      ".menu-item-has-children.menu-item-has-mega-menu,.menu-item-has-children>.offset-bar:not(.xg-mega-menu-container)>ul>li,.menu-item-has-children:not(.category-list)>ul>li>ul>li"
    );
    $(document).on("mouseenter", ".search-category ul>li", function () {
      $(this).addClass("active").siblings().removeClass("active");
    });
  }),
    /*====== end CategoryList ======*/

    /*====== ResponsiveHeader ======*/
    (HAMTA.ResponsiveHeader = function () {
      $(document).on(
        "click",
        ".header-responsive .btn-toggle-side-navigation",
        function (event) {
          $(this).siblings(".side-navigation").addClass("toggle");
        }
      );
      $(document).on(
        "click",
        ".header-responsive .side-navigation ul > li.has-children",
        function (event) {
          if ($(event.target).is("li")) {
            event.preventDefault();
            event.stopPropagation();
            $(this).toggleClass("active");
            $(this).find("ul:first").slideToggle(100);
          }
        }
      );
      $(document).on(
        "click",
        ".header-responsive .btn-close-filter-sidebar",
        function (event) {
          $(".side-navigation").removeClass("toggle");
        }
      );
    });
  /*====== end ResponsiveHeader ======*/

  /*====== NiceScroll ======*/
  HAMTA.NiceScroll = function () {
    const scroll = $(".do-nice-scroll");
    if (scroll.length)
      $(".do-nice-scroll").niceScroll({
        railalign: "left",
      });
  };

  HAMTA.Countdown = function () {
    $(".countdown-offer").each(function () {
      const elm = $(this);
      let distance = Number(elm.data("end")) * 1000;
      const x = setInterval(function () {
        distance -= 1000;
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        let text = "";
        if (days > 0) text += (days < 10 ? "0" + days : days) + ":";
        text +=
          (hours < 10 ? "0" + hours : hours) +
          ":" +
          (minutes < 10 ? "0" + minutes : minutes) +
          ":" +
          (seconds < 10 ? "0" + seconds : seconds);
        elm.find("span").html(text);
        if (distance < 0) {
          clearInterval(x);
          elm.html("00:00:00");
        }
      }, 1000);
    });
  };

  HAMTA.VideoModal = function () {
 $(document).on("click", "[data-dismiss='modal']", function () {
    const video = document.querySelector("#videoModal video");
    if (video) {
        video.pause();
    }
    $("#videoModal").find(".embed_code").html("");
});

    $(".video-gallery .video-item").click(function () {
      const code = $(this).data("code");
      const videoModal = $("#videoModal");
      videoModal.find(".modal-title").html($(this).data("title"));
      if ($(this).data("method") == "direct_link") {
        const video = document.querySelector("#videoModal video");
        video.setAttribute("poster", $(this).find("img").attr("src"));
        video.querySelector("source").setAttribute("src", code);
        video.load();
        videoModal.find(".direct_link").removeClass("d-none");
        videoModal.find(".embed_code").addClass("d-none");
      } else {
        videoModal.find(".direct_link").addClass("d-none");
        videoModal.find(".embed_code").html(code).removeClass("d-none");
      }
      videoModal.modal();
    });
  };
  /*====== end NiceScroll ======*/

  /*====== BackToTop ======*/
  HAMTA.BackToTop = function () {
    $(".back-to-top").click(function () {
      $("body,html").animate(
        {
          scrollTop: 0,
        },
        700
      );
      return false;
    });
  };
  HAMTA.Modal = function () {
    $.fn.modal = function (status = "show") {
      if (status == "show") {
        $(".GeneralOverlay_GeneralOverlay__ZT9dx").addClass("z-99");
        window.dispatchEvent(new CustomEvent("lock-scroll"));
        document
          .querySelector("#" + this.attr("id"))
          ?.dispatchEvent(new CustomEvent("modal-show"));
        this.addClass("show");
      } else {
        $(".GeneralOverlay_GeneralOverlay__ZT9dx").removeClass("z-99");
        window.dispatchEvent(new CustomEvent("unlock-scroll"));
        document
          .querySelector("#" + this.attr("id"))
          ?.dispatchEvent(new CustomEvent("modal-hide"));
        this.removeClass("show");
      }
    };
    $(document).on("click", "[data-toggle=modal]", function () {
      $($(this).data("target")).modal("show");
    });
    $(document).on("click", "[data-dismiss=modal]", function () {
      $(this).parents(".modal").modal("hide");
    });
    $(document).on("click", ".modal", function (e) {
      e.stopPropagation();
      if (
        !$(this).hasClass("static") &&
        !$(e.target).hasClass("modal-content") &&
        !$(e.target).parents(".modal-content").length
      ) {
        $(this).modal("hide");
      }
    });
  };
  /*====== end BackToTop ======*/

  /*====== end productAddTo ======*/

  /*====== Select2 ======*/
  HAMTA.Select2 = function () {
    let select2 = $(".select2");
    if (select2.length) {
      $(".select2").each(function () {
        if ($(this).hasClass("select2-hidden-accessible")) {
          $(this).select2("destroy");
          $(this).next(".select2-container").remove();
        }
      });
      select2.select2({closeOnSelect: false});
    }
  };

  /*====== sidebar-sticky ======*/
 HAMTA.StickySidebar = function () {
    const stickyElements = document.querySelectorAll('.theiaStickySidebar');

    if (!stickyElements.length) return;

    const header = document.querySelector('header.page-header');
    const headerHeight = header ? header.offsetHeight : 0;

    stickyElements.forEach(el => {
        const additional = parseInt(el.dataset.additional || 0);
        el.style.top = (headerHeight + additional) + "px";
    });
};

  /* end sidebar-sticky ======*/

  /* end color switcher ======*/
  document.addEventListener("DOMContentLoaded", () => {
    HAMTA.Modal(),
    HAMTA.StickyHeader(),
      HAMTA.CategoryList(),
      HAMTA.ResponsiveHeader(),
      HAMTA.NiceScroll(),
      HAMTA.BackToTop();
  });
})(jQuery);
